import { MoreOutlined } from '@ant-design/icons'
import { Styles } from '@types'
import { Button, Dropdown, Menu, Table, TableColumnType, TablePaginationConfig, Tag } from 'antd'
import { Services } from 'gadjet-v2-types/dist/model'
import { CreditType, Pagination } from 'gadjet-v2-types/dist/type'
import { creditType } from 'gadjet-v2-types/dist/type/label'

import { BranchServiceAction } from '@pages/Authorized/Branch/ServicePage'

import ContentWrapper from '@components/atoms/ContentWrapper'

type Props = {
  loading: boolean
  total: number
  pagination: Pagination
  services: Services[]
  onChangePagination: (pagination: Pagination) => void
  onAction: (action: BranchServiceAction, serviceId: number) => void
}
export default function BranchServiceListTable({
  loading,
  total,
  pagination,
  services,
  onChangePagination,
  onAction,
}: Props): JSX.Element {
  const onChange = (_pagination: TablePaginationConfig) => onChangePagination({ ...pagination, ..._pagination })

  const columns: TableColumnType<Services>[] = [
    { key: 'name', dataIndex: 'name', title: '이름' },
    { key: 'description', dataIndex: 'description', title: '설명' },
    {
      key: 'price',
      dataIndex: 'price',
      title: '가격',
      render: (price) => `${price} 크레딧`,
    },
    {
      key: 'salesAmount',
      dataIndex: 'salesAmount',
      title: '판매량',
      render: (salesAmount) => `${salesAmount || 0}개`,
    },
    {
      key: 'availableCreditType',
      dataIndex: 'availableCreditType',
      title: '크레딧',
      render: (availableCreditType: CreditType[]) =>
        availableCreditType.map((type) => <Tag key={type}>{creditType[type]}</Tag>),
    },
    { key: 'guide', dataIndex: 'guide', title: '가이드' },
    {
      key: 'serviceId',
      dataIndex: 'serviceId',
      title: '',
      width: '80px',
      render: (serviceId) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="update" onClick={() => onAction('update', serviceId)}>
                수정
              </Menu.Item>
              <Menu.Item key="delete" onClick={() => onAction('delete', serviceId)}>
                제거
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger={['click']}
        >
          <Button icon={<MoreOutlined />} size="large" type="text" />
        </Dropdown>
      ),
    },
  ]

  return (
    <ContentWrapper>
      <Table<Services>
        loading={loading}
        style={styles.table}
        scroll={{ x: true }}
        rowKey={({ serviceId }) => `${serviceId}`}
        dataSource={services}
        columns={columns}
        onChange={onChange}
        pagination={{
          total,
          position: ['bottomRight'],
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
      />
    </ContentWrapper>
  )
}

const styles: Styles = {
  table: { whiteSpace: 'pre-wrap', wordBreak: 'keep-all' },
}
